export default __webpack_public_path__ + "fonts/fontello.a7f7465b23a04f31f273156b9748e4bb.woff";